import * as React from 'react';
import { useCallback, useState } from 'react';

import SkillsAndToolsDialog from 'bundles/unified-description-page-common/components/modules/product-overview/SkillsAndToolsDialog';
import SkillsAndToolsDialogContext from 'bundles/unified-description-page-common/contexts/SkillsAndToolsDialogContext';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type Props = {
  skillTags?: ConsumerSpecializationPageFieldsFragment['skillTags'];
  children: React.ReactNode;
};

const SkillsAndToolsDialogProvider = ({ children, skillTags }: Props) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isSkillsLinkingEnabled, setIsEnableSkillsLinking] = useState(false);

  const openDialog = useCallback<() => void>(() => {
    setDialogOpen(true);
  }, []);
  const closeDialog = useCallback<() => void>(() => setDialogOpen(false), []);

  if (!skillTags || skillTags.length === 0) {
    return <>{children}</>;
  }

  return (
    <SkillsAndToolsDialogContext.Provider
      value={{
        isDialogOpen,
        openDialog,
        closeDialog,
        isSkillsLinkingEnabled,
        setIsEnableSkillsLinking,
      }}
    >
      {children}
      <SkillsAndToolsDialog open={isDialogOpen} onClose={closeDialog} skillTags={skillTags} />
    </SkillsAndToolsDialogContext.Provider>
  );
};

export default SkillsAndToolsDialogProvider;
